import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import '@utils/ssr/interval-timeout-shim';
import '@utils/polyfills';
import DynamicPricingCalculator from './App';
import '@styles/general.scss';

if (process.env.NODE_ENV === 'development') {
  const props = window.initialProps ?? {};

  ReactDOM.render(
    <DynamicPricingCalculator {...props} />,
    document.getElementById('app')
  );
}

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.Components = { DynamicPricingCalculator };
